import { render, staticRenderFns } from "./coberturasEditables.vue?vue&type=template&id=87f3e900"
import script from "./coberturasEditables.vue?vue&type=script&lang=js"
export * from "./coberturasEditables.vue?vue&type=script&lang=js"
import style0 from "./coberturasEditables.vue?vue&type=style&index=0&id=87f3e900&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRow,VSelect})
